export const talentType = {
	racial: 'Racial talent',
	story: 'Story talent',
};

export const talent = {
	allSkilledUp: 'All Skilled Up',
	allSkilledUpDescription: 'All Skilled Up immediately gives you 1 extra Combat ability point and 1 extra Civil ability point.',
	allSkilledUpDetails: 'Requires Level 2',
	ancestralKnowledge: 'Ancestral Knowledge',
	ancestralKnowledgeDescription: 'Ancestral Knowledge gives you +1 Loremaster.',
	ambidextrous: 'Ambidextrous',
	ambidextrousDescription: 'Ambidextrous reduces the cost of using grenades and scrolls by 1 AP when your offhand is free.',
	arrowRecovery: 'Arrow Recovery',
	arrowRecoveryDescription: 'Arrow Recovery gives you 33% chance to recover a special arrow after shooting it.',
	biggerAndBetter: 'Bigger And Better',
	biggerAndBetterDescription: 'Bigger And Better immediately grants you 2 extra attribute point to spend.',
	biggerAndBetterDetails: 'Requires Level 2',
	comebackKid: 'Comeback Kid',
	comebackKidDescription:
			'Once per combat, if an enemy lands a fatal blow, Comeback Kid will help you bounce back to life with 20% health. ' +
			'If you die and are resurrected in combat, Comeback Kid will be available again.',
	corpseEater: 'Corpse Eater',
	corpseEaterDescription: 'Corpse Eater lets you eat body parts to access the memories of the dead.',
	demon: 'Demon',
	demonDescription:
			'A character with Demon has an extra 15% Fire Resistance, but takes a 15% penalty to Water Resistance. ' +
			'Additionally, the maximum Fire Resistance is raised by 10.',
	demonDetails: 'Requires Pyrokinetic 1\nIncompatible with Ice King',
	duckDuckGoose: 'Duck Duck Goose',
	duckDuckGooseDescription: 'Duck Duck Goose lets you evade attacks of opportunity.',
	duckDuckGooseDetails: 'Requires Huntsman 1',
	dwarvenGuile: 'Dwarven Guile',
	dwarvenGuileDescription: 'Dwarven Guile gives you +1 in Sneaking.',
	elementalAffinity: 'Elemental Affinity',
	elementalAffinityDescription:
			'Elemental Affinity lowers the Action Point cost of spells by 1 when standing in a surface of the same element.',
	escapist: 'Escapist',
	escapistDescription: 'Escapist allows you to flee combat even when enemies are right next to you.',
	executioner: 'Executioner',
	executionerDescription: 'Executioner gives you 2 extra Action Points after dealing a killing blow.',
	executionerDetails: 'Requires Warfare 1\nIncompatible with The Pawn',
	elementalRanger: 'Elemental Ranger',
	elementalRangerDescription: 'Shooting arrows will inflict bonus elemental damage depending on the surface your target is standing in.',
	elementalRangerDetails: 'Requires Huntsman 1',
	farOutMan: 'Far Out Man',
	farOutManDescription: 'Far Out Man increases the range of skills and scrolls by 2m. Does not affect melee and touch-range skills.',
	fiveStarDiner: 'Five-Star Diner',
	fiveStarDinerDescription: 'Five-Star Diner doubles the effects of food and potions.',
	glassCannon: 'Glass cannon',
	glassCannonDescription:
		'With Glass Cannon, you start every combat round with Maximum AP, but Magic and Physical Armour do not protect you from statuses.',
	glassCannonDetails: 'Incompatible with Lone Wolf',
	guerrilla: 'Guerrilla',
	guerrillaDescription: 'While sneaking, Guerrilla increases attack damage by 40%. Also reduces cost of entering sneak mode by 1 AP.',
	hothead: 'Hothead',
	hotheadDescription: 'While you are at maximum Vitality, Hothead grants you an extra 10% critical chance and 10% more accuracy!',
	iceKing: 'Ice King',
	iceKingDescription:
			'A character with Ice King has an extra 15% Water Resistance, but takes a 15% penalty to Fire Resistance. ' +
			'Additionally, the maximum Water Resistance is raised by 10.',
	iceKingDetails: 'Requires Hydrosophist 1\nIncompatible with Demon',
	ingenious: 'Ingenious',
	ingeniousDescription: 'Ingenious gives you 5% bonus Critical Chance and 10% extra Critical Multiplier.',
	leech: 'Leech',
	leechDescription: 'Leech heals you when standing in blood.',
	livingArmour: 'Living Armour',
	livingArmourDescription: 'Living Armour adds 35% of all healing you receive by skills or consumables to your Magic Armour.',
	lonewolf: 'Lone Wolf',
	lonewolfDescription:
			'Lone Wolf provides +2 Max AP, +2 Recovery AP, +30% Vitality, +60% Physical Armour, +60% Magic Armour, ' +
			'and doubles invested points in attributes - up to a maximum of 40 - and combat abilities (except Polymorph ability) ' +
			'- up to a maximum of 10 - while you are adventuring solo or with at most one companion.',
	lonewolfDetails:
		'This bonus is temporarily removed while there are more than two members in the current party. ' +
		'Click on their portraits to send them resting or to reinvite.\n' +
		'Incompatible with Glass Cannon',
	lonewolfInactive: 'Lone Wolf (inactive)',
	mnemonic: 'Mnemonic',
	mnemonicDescription: 'Mnemonic gives you 3 extra points in your Memory attribute.',
	morningPerson: 'Morning Person',
	morningPersonDescription: 'When resurrected, you resurrect to full health.',
	opportunist: 'Opportunist',
	opportunistDescription: 'Opportunist gives you the ability to perform attacks of opportunity.',
	parryMaster: 'Parry Master',
	parryMasterDescription: 'Parry Master gives you 10% Dodging while dual wielding.',
	petPal: 'Pet Pal',
	petPalDescription: 'Pet Pal enables you to talk to animals.',
	pictureOfHealth: 'Picture Of Health',
	pictureOfHealthDescription: 'Picture Of Health gives you extra Vitality: +3% for every point in Warfare.',
	pictureOfHealthDetails: 'Requires Warfare 1',
	rooted: 'Rooted',
	rootedDescription: 'Rooted gives you 3 extra points in your Memory attribute.',
	rootedDetails: 'Exclusive to Sebille',
	savageSortilege: 'Savage Sortilege',
	savageSortilegeDescription: 'Savage Sortilege gives all magical skills a critical chance equal to your critical chance score.',
	slingshot: 'Slingshot',
	slingshotDescription: 'Slingshot adds an extra 5m range to your grenade throws.',
	sophisticated: 'Sophisticated',
	sophisticatedDescription: 'Sophisticated gives you +10% Fire Resistance and +10% Poison Resistance.',
	spellsong: 'Spellsong',
	spellsongDescription: 'You get +1 Persuasion from Spellsong.',
	spidersKissTO: "Spider's kiss: Towering Oak",
	spidersKissTODescription: "Spider's Kiss gives you -2 to Constitution and +2 to Strength.",
	spidersKissCQ: "Spider's kiss: Curved Quill",
	spidersKissCQDescription: "Spider's Kiss gives you -2 to Constitution and +2 to Intelligence.",
	spidersKissGC: "Spider's kiss: Golden Chest",
	spidersKissGCDescription: "Spider's Kiss gives you -2 to Constitution and 2000 gold.",
	spidersKissSD: "Spider's kiss: Stately Dragon",
	spidersKissSDDescription: "Spider's Kiss gives you -2 to Constitution and +2 to Wits.",
	spidersKissTC: "Spider's kiss: Chrysalis",
	spidersKissTCDescription: "Spider's Kiss gives you -2 to Constitution and a Glowing Idol of Rebirth.",
	spidersKissTCDetails: 'Can only be picked once',
	stench: 'Stench',
	stenchDescription: "Stench decreases everyone's attitude towards you by 25, but melee opponents find you less attractive in combat.",
	sturdy: 'Sturdy',
	sturdyDescription: 'Sturdy gives you +10% maximum Vitality and +5% Dodging.',
	thePawn: 'The Pawn',
	thePawnDescription: 'The Pawn permits your character 1 AP worth of free movement per turn.',
	thePawnDetails: 'Requires Scoundrel 1\nIncompatible with Executioner',
	thrifty: 'Thrifty',
	thriftyDescription: 'Thrifty gives you +1 to Bartering.',
	torturer: 'Torturer',
	torturerDescription:
			'With Torturer, certain statuses caused by you are no longer blocked by Magic or Physical Armour, ' +
			'and their duration is extended by one turn. Burning, Poisoned, Bleeding, Necrofire, Acid, Suffocating, ' +
			'Entangled, Death Wish, and Ruptured Tendons are affected by this talent.',
	tradeSecrets: 'Trade secrets',
	tradeSecretsDescription: 'Trade Secrets gives you +1 to Bartering.',
	tradeSecretsDetails: 'Requires Corpse Eater\nCan only be picked once',
	trainingAuthority: 'Master Of Authority',
	trainingAuthorityDescription: 'Master Of Authority gives you +5 to Memory and -5 to Strength.',
	trainingIntelligence: 'Master Of Intelligence',
	trainingIntelligenceDescription: 'Master Of Intelligence gives you +5 to Intelligence and -5 to Finesse.',
	trainingWits: 'Master Of Wits',
	trainingWitsDescription: 'Master Of Wits gives you +5 to Wits and -5 to Constitution.',
	trainingFinesse: 'Master Of Finesse',
	trainingFinesseDescription: 'Master Of Finesse gives you +5 to Finesse and -5 to Memory.',
	trainingConstitution: 'Master Of Constitution',
	trainingConstitutionDescription: 'Master Of Constitution gives you +5 to Constitution and -5 to Intelligence.',
	trainingStrength: 'Master Of Strength',
	trainingStrengthDescription: 'Master Of Strength gives you +5 to Strength and -5 to Wits.',
	undead: 'Undead',
	undeadDescription:
			'Undead lets you heal from poison, but regular healing will damage you instead. ' +
			'You will receive Poisoned status even if you have Magic Armour.',
	unstable: 'Unstable',
	unstableDescription:
			'Unstable makes you explode in a bloody cloud when you die, dealing 50% of your Vitality as physical damage in a 3 meter radius.',
	walkItOff: 'Walk It Off',
	walkItOffDescription:
			'Walk It Off reduces all status durations by 1 turn, including positive statuses. ' +
			'Does not affect statuses with a duration of 1 turn.',
	whatARush: 'What A Rush',
	whatARushDescription: 'What A Rush increases your recovery and maximum Action Points by 1 when your health is below 50%.',
};
